import { User, UserAction, UserActions } from "../model";

export function setUser(user: User): UserAction {
	return {
		type: UserActions.SET_USER,
		payload: user,
	};
}
